import React, { useState } from "react";
import "./Speedometer_holder.css";
import Mango_Color_Btn from "../../../../Common_Btn/Mango_Color_Btn/Mango_Color_Btn";
import ReactSpeedometer from "react-d3-speedometer";

function Speedometer_holder({setQualification,qualification}) {
  const [speedometerValue, setSpeedometerValue] = useState(3); // Default value

  // Function to handle button click and update speedometer value
  const handleButtonClick = (value,q) => {
    setSpeedometerValue(value);
    setQualification(q);
  };

  console.log(qualification,"qualification");
  
  return (
    <div className="Speedometer_holder">
      {/* Buttons Positioned Around Speedometer */}
      <div className="education_labels">
        <div className="below_10th">
          <Mango_Color_Btn 
            btn_name="Below 10th"  
            extraClass={qualification === "Below 10th" ? "active" : ""}
            onClick={() => handleButtonClick(1,'Below 10th')}
          />
        </div>
        <div className="tenth_pass">
          <Mango_Color_Btn 
            btn_name="10th Pass" 
            
            extraClass={qualification === "10th Pass" ? "active" : ""}
            // extraClass={speedometerValue === 2 ? "active" : ""}
            onClick={() => handleButtonClick(2,'10th Pass')}
          />
        </div>
        <div className="twelfth_pass">
          <Mango_Color_Btn 
            btn_name="12th Pass" 
            extraClass={qualification === "12th Pass" ? "active" : ""}
            onClick={() => handleButtonClick(3,'12th Pass')}
          />
        </div>
        <div className="graduate">
          <Mango_Color_Btn 
            btn_name="Graduate & Above" 
            extraClass={qualification === "Graduate & Above" ? "active" : ""}
            // extraClass={speedometerValue === 4 ? "active" : ""}
            onClick={() => handleButtonClick(4,'Graduate & Above')}
          />
        </div>
      </div>

      {/* Speedometer */}
      <div className="main_speedometer_holder">
        <ReactSpeedometer
          maxValue={4}
          minValue={1}
          value={speedometerValue}
          segments={4}
          needleColor="orangered"
          startColor="#7ea6e0"
          endColor="#0a1e61"
          textColor="black"
          ringWidth={50}
          segmentColors={["#7ea6e0", "#4f72b5", "#2e4a99", "#0a1e61"]}
          currentValueText=""
        />
      </div>
    </div>
  );
}

export default Speedometer_holder;
